module.exports = __webpack_public_path__ + "img/empty_team.fe1d9856.jpg";